import './trigger-customer-signin-user.js'
import './trigger-register-user.js'
import './verify-recovery-factor-graphql.js'
import './verify-recovery-factor.js'
import './resend-recovery-factor.js'
// import "./trigger-send-state-factor.js"
// import './trigger-verify-state-factor.js'
import './trigger-customer-profile.js'
// import './trigger-verify-user.js'
// import './trigger-customer-lookup.js'
// import '/storage-service.js'
import './v2/progress-bar-v2.js'
import  "./otp-service.js"


// import './add-bank.js'
// import './whatsapp-option.js'
// import './v2/full-registration.js'
import './v2/beast-redirect-v2.js'
import './v2/country-code-dropdown-v2.js'
import './v2/receiver-name-change-v2.js'
import './v2/country-code-dropdown-v2.js'
import './v2/receiver-name-change-v2.js'
import './v2/mexico-complaint-form-v2.js'
// import './v2/otp-screen.js'
import './v2/refund-flow.js';
